import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!

  return (_openBlock(), _createBlock(_component_n_tag, {
    class: "text-xs px-3 font-semibold rounded-2xl",
    bordered: false,
    type: _ctx.type
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.color)
      }, _toDisplayString(_ctx.text), 3)
    ]),
    _: 1
  }, 8, ["type"]))
}